var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card mt-1"},[_c('div',{staticClass:"card-header text-left"},[_vm._v(" MBA Network Graph ")]),_c('div',{staticClass:"card-body"},[_c('img',{attrs:{"src":"/img/nw_graph_top_20_rules.png","width":"800px","height":"500px"}})])])])
}]

export { render, staticRenderFns }